import axios from 'axios';
import { API_KEY, API_SECRET, BASEURL } from '../pages/Constants';

export const getAccessToken = (): string | null => {
  const userString = localStorage.getItem('user');

  if (!userString) {
    return null;
  }

  try {
    const user = JSON.parse(userString);
    const accessToken = user?.accessToken || null;
    return accessToken;
  } catch (error) {
    console.error('Error parsing user data');
    return null;
  }
};

const instance = axios.create({
  baseURL: `${BASEURL}`,
  headers: {
    'Content-type': 'application/json',
    'X-API-SECRET': `${API_SECRET}`,
    'X-API-KEY': `${API_KEY}`
  },
});

// Add request interceptor to include fresh token with each request
instance.interceptors.request.use((config) => {
  const accessToken = getAccessToken();

  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Add response interceptor to handle authentication errors
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear user data and redirect to sign in
      localStorage.removeItem('user');
      window.location.href = '/auth/signin';
    }
    return Promise.reject(error);
  }
);

export default instance;

